import React, { Fragment, useState, useEffect } from "react";
import { ACCOUNT_SIDEBAR_ITEMS } from "../../constants/AppEnums";
import UserAccountSidebarView from "./UserAccountSidebarView";
import ROUTES_PATH from "../../constants/RouteConstants";
import {
  MainContainer,
  MainGridContainer,
  MainArea,
  SidebarArea,
} from "./UserAccountView.styles";
import UserAccountOrganizationsView from "./UserAccountOrganizationsView";
import UserAccountMembersView from "./UserAccountMembersView";
import UserAccountProfileView from "./UserAccountProfileView";
import UserAccountSettingsView from "./UserAccountSettingsView";
import UserAccountUsageView from "./UserAccountUsageView";
import UserAccountPlanView from "./UserAccountPlanView";
import UserAccountDepositView from "./UserAccountDepositView";


const UserAccountView = () => {
  const [activeItemId, setActiveItemId] = React.useState(ROUTES_PATH.PROFILE);

    

  return (
    <Fragment>
      <MainContainer>
        <MainGridContainer>
          <SidebarArea  span={[1, 2, 2]}>
            <UserAccountSidebarView
              onSelectedChanged={(itemId) => setActiveItemId(itemId)}
              items={ACCOUNT_SIDEBAR_ITEMS}
            />
          </SidebarArea>
          <MainArea  span={[4, 8, 8]}>
            {activeItemId === ROUTES_PATH.PROFILE && <UserAccountProfileView />}
            {activeItemId === ROUTES_PATH.ORGANIZATIONS && (
              <UserAccountOrganizationsView />
            )}
            {activeItemId === ROUTES_PATH.USAGE && <UserAccountUsageView />}
            {activeItemId === ROUTES_PATH.BILLING && <UserAccountPlanView />}
            {activeItemId === ROUTES_PATH.MEMBERS && <UserAccountMembersView />}
            {activeItemId === ROUTES_PATH.ORGANIZATION && <UserAccountSettingsView />}
            {activeItemId === ROUTES_PATH.DEPOSIT && <UserAccountDepositView />}
          </MainArea>
        </MainGridContainer>          
      </MainContainer>
    </Fragment>
  );
};

export default UserAccountView;
